import { useState, useEffect } from "react";
import { supabase } from "../../../lib/supabase";
import { LOTTERY_TYPES } from "../../../config/lotteryConfig";
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

export default function LotteryNumlotStatsContainer({ lotteryKey, Template }) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      NProgress.start();
      setLoading(true);
      try {
        const { data, error } = await supabase
          .schema('chatorahack')
          .rpc('get_lottery_numlot_stats', {
            p_lottery_key: lotteryKey,
          });

        if (error) throw error;
        setStats(data);
      } catch (err) {
        setStats(null);
      } finally {
        setLoading(false);
        NProgress.done();
      }
    };

    fetchStats();
  }, [lotteryKey]);

  const config = LOTTERY_TYPES[lotteryKey];

  return <Template stats={stats} config={config} loading={loading} />;
}